import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "value", "choice", "custom"]
  declare readonly inputTarget: HTMLInputElement
  declare readonly valueTarget: HTMLInputElement
  declare readonly choiceTargets: HTMLInputElement[]
  declare readonly customTarget: HTMLElement

  connect() {
    const reason = this.valueTarget.value.trim().toLocaleLowerCase()
    const match = this.choiceTargets.find(choice => choice.dataset.passReasonLabel!.toLocaleLowerCase() === reason)
    const selected = match || (reason ? this.choiceTargets.find(choice => choice.value === "other") : undefined)
    if (selected) selected.checked = true
    this.inputTarget.value = selected?.value === "other" ? this.valueTarget.value : ""
    this.render()
    if (selected?.value === "other") this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  choose() {
    this.update()
    if (!this.customTarget.hidden) this.inputTarget.focus()
  }

  update() {
    const choice = this.choiceTargets.find(choice => choice.checked)
    this.valueTarget.value = choice?.value === "other" ? this.inputTarget.value : (choice?.dataset.passReasonLabel || "")
    this.render()
  }

  private render() {
    const custom = this.choiceTargets.some(choice => choice.checked && choice.value === "other")
    this.customTarget.hidden = !custom
    this.inputTarget.disabled = !custom
    this.inputTarget.required = custom
  }
}
